import React, {useEffect, useState} from "react"
import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
import timezone from "dayjs/plugin/timezone"
import localizedFormat from "dayjs/plugin/localizedFormat"

import localeData from "dayjs/plugin/localeData"
import locales from "dayjs/locale.json"
import "dayjs/locale/nb"

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(localizedFormat)
dayjs.extend(localeData)

type TimeStampProps = {
    timestamp: number | string
    dateOnly?: boolean
}

export default function TimeStamp(props: TimeStampProps) {
    const formatTimestamp = (timestamp: number | string, locale: string) => dayjs(timestamp)
        .utc(true)
        .tz(userZone)
        .locale(locale)
        .format(props.dateOnly ? "LL" : "LLL")

    const userZone = dayjs.tz.guess()
    const [locale, setLocale] = useState<string>("en")
    const [timestamp, setTimestamp] = useState(formatTimestamp(props.timestamp, locale))

    useEffect(() => {
        const preferredLocales = navigator.languages.map(lang => {
            return locales.find(locale => locale.key == lang)
        }).filter(lang => lang != undefined)

        setLocale(() => preferredLocales[0]?.key ?? "en")
    }, [])

    useEffect(() => {
        setTimestamp(formatTimestamp(props.timestamp, locale))
    }, [locale])

    return <time>
        {timestamp}
    </time>

}
